<div class="main neutral-theme">
  <app-member-logo-name [logoUrl]="logoUrl"></app-member-logo-name>
  <div class="container">
    <router-outlet></router-outlet>
  </div>
  <div class="footer" fxLayout="column" fxLayoutAlign="start center">
    @if (helpLink) {
      <div class="help-bar">
        <a href="{{ helpLink }}" class="help">Need help?</a>
      </div>
    }
    <div class="footer-bar" fxLayoutAlign="center center">
      <span class="powered-by">powered by</span>
      <a
        href="https://www.lineupteams.com"
        target="_blank"
        aria-label="Lineup, click to learn more about Lineup"
      >
        <img src="../assets/img/LineupLogo.png" alt="" />
      </a>
    </div>
  </div>
</div>
